<template>
    <div class="h-100 w-100 d-flex flex-column justify-content-start align-items-center overflow-auto">
      <div class="welcome-heading">
        <h1 class="text-black font-80 mb-2">Welcome!</h1>
        <label class="text-black font-40 font-weight-400 mb-2">Choose one of these videos below to start</label>
      </div>
      <div class="container-fluid discover-container">
        <div v-if="videos && videos.length > 0">
          <div class="horizontal-width video-box-main">
            <div class="row  video-box"
                 v-for="(tenant, index) in groupedVideos" :key="index">
              <div class="col-lg-12  " ref="workoutComponent" >
                <workout-component
                    :id="tenant.id"
                    :title="tenant.title"
                    :thumbnail="tenant.thumbnail"
                    :duration="tenant.duration"
                    :tenantName="tenant.tenantName"
                    :categories="tenant.categories"
                    :intensity="tenant.intensity"
                    @thumbnailHeight="setNavigationHeight">
                </workout-component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import workoutComponent from "./WorkoutComponent.vue";
import { createNamespacedHelpers, mapState } from "vuex";
const { mapActions, mapState: mapDashboardState } = createNamespacedHelpers("campaign");

export default {
  components: {
    workoutComponent
  },
  computed: {
    ...mapDashboardState(["isDashboardLoading", "videos", "campaign"]),
    ...mapState(["userInfo", "dashboardLoading"]),
    groupedVideos() {
      return this.videos;
    },
    videoLimiter() {
			return window.matchMedia("(orientation: landscape)").matches ? 15 : 10;
		},
  },
  methods: {
    ...mapActions(["getCampaignDetails", "getCampaignVideos"]),
    setNavigationHeight(val) {
      this.navigationHeight = val + "px";
    },
  },
  async created() {
    const details = await this.getCampaignDetails(this.$route.params.name);
    if (!details) {
      await this.$router.push({ name: "Not Found" });
    }
  },
  async mounted() {
    await this.getCampaignVideos(this.$route.params.name);
  }
}
</script>

<style lang="scss" scoped>
.horizontal-width{
     display: grid !important;
    grid-template-columns: auto auto auto !important;
    gap: 5px !important;
    margin: auto !important;
    justify-content: space-around !important;
}
.horzintal-width-1{
      width: 100% !important;
}
.discover-container {
  text-align: left !important;
}
.ef-logo-text{
  padding: 25px;
}

.ef-logo {
    width: 55px;
    height: auto;
    margin: 0 5px;
}

.background-texture {
    background-image: url("../assets/images/bg-fitsummit.png");
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    min-height: 100vh;
    position: relative;
}

.welcome-heading {
    margin-top: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.welcome-heading h1 {
    margin: 0 !important;
    font-size: 75px;
    line-height: 90px;
    font-weight: 700;
    color: #000;
}

.welcome-heading label {
    margin: 0 !important;
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 100px !important;
    color: #2c2c2c;
}

.video-box-main {
    width: 100% !important;
    max-width: 1920px;
    padding: 0 30px !important;
    margin-bottom: 40px !important;
}

.video-box {
    background-color: #fff;
    box-shadow: rgb(0 0 0 / 24%) 3px 3px 3px 1px;
    padding: 20px 8px;
    margin: 0 20px !important;
    width: auto !important;
    align-content: flex-start !important;
    margin-bottom: 35px !important;
}
</style>
